import styled from 'styled-components/macro';

const CtaBarFormFooter = styled.div`
  padding: 25px 50px;

  p {
    color: gray;
    font-size: 10px;
  }
`;

export default CtaBarFormFooter;
